// import PersonnelInformation from "../pages/HRINF/ApplicantInformation/PersonnelInformation";
import { lazy } from "react";
// import JobApply from "../pages/HRINF/ApplicantInformation/JobApply/JobApply";

// const PersonnelInformation = lazy(() =>
//   import("../pages/HRINF/ApplicantInformation/PersonnelInformation")
// );
const PersonnelInformation = lazy(() =>
  import("../pages/HRINF/ApplicantInformation/MainPage/PersonnelInformation")
);

const applicantformsRoute = [
  {
    type: "add",
    key: Math.ceil(Math.random()) * 100000,
    path: "/personnel-information/add/:firstName/:lastName/:nationalCode/:cellphone",
    element: <PersonnelInformation observe={false} edit={false} fromDraft={false} />,
  },
  {
    type: "edit",
    key: Math.ceil(Math.random()) * 100000,
    path: "/personnel-information/edit/:firstName/:lastName/:nationalCode/:cellphone",
    element: <PersonnelInformation observe={false} edit={true} fromDraft={false} />,
  },
  {
    type: "edit",
    key: Math.ceil(Math.random()) * 100000,
    path: "/personnel-information/333status/:firstName/:lastName/:nationalCode/:cellphone",
    element: (
      <PersonnelInformation
        observe={false}
        edit={true}
        fromDraft={false}
        getByNationalCode={true}
        editHr={true}
      />
    ),
  },
  // {
  //   type: "add",
  //   key: Math.ceil(Math.random()) * 100000,
  //   path: "/JobApply/add",
  //   element: <PersonnelInformation observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   type: "add",
  //   key: Math.ceil(Math.random()) * 100000,
  //   path: "/job-apply/edit/:id",
  //   element: <PersonnelInformation observe={false} edit={false} fromDraft={false} editHr={true} />,
  // },
];

export default applicantformsRoute;
